import {decorationStyles} from "./decoration.css";
import {layoutStyles} from "./layout.css";
import {colorThemes} from "./themes/themes.css";
import {typeStyles} from "./type.css";
import {utilStyles} from "./utils.css";

const dsStyles = {
  ...layoutStyles,
  ...typeStyles,
  ...decorationStyles,
  ...utilStyles,

  colorTheme: colorThemes,
};

export default dsStyles;

export type DsStyles = typeof dsStyles;
